module.exports = __webpack_public_path__ + "img/u1014.627c5b01.svg";